<template>
  <div class="swiper-box">
    <!-- Swiper -->
    <div class="swiper-container" id="home-banner-swiper-container">
      <div class="swiper-wrapper" :class="{'reset-translateY':sliceActive%2!=0}">
        <div class="swiper-slide" v-for="(item, index) in productList" :key="index">
          <router-link :to="'/ProductDetails/' + item.id">
            <div class="top-slide">
              <div class="img-box">
                <div class="show-img-box">
                  <div class="big-img">
                    <img :src="item.maxImage">
                  </div>
                  <div class="small-img" v-if="item.minImage">
                    <img :src="item.minImage">
                  </div>
                </div>
                <div class="fade-img">
                  <img :src="item.image">
                </div>
                <div class="product-info">
                  <h2 class="title">{{ item.name }}</h2>
                  <h3 class="sub-title">“{{ item.subhead }}”</h3>
                  <p class="energy-info"><img src="../../assets/images/fire.svg"> {{ item.ingredient }}</p>
                </div>
              </div>
            </div>
          </router-link>

        </div>
      </div>
      <div  id="swiper-home-banner-prev-button">
      </div>
      <div  id="swiper-home-banner-next-button">
      </div>
    </div>

  </div>
</template>
<script>
  import API from "../config/api.js";
  export default {
    name: 'Banner',
    data() {
      return {
        productList: [],
        sliceActive: 1 
      }
    },
    components: {},
    methods: {
      getWebHomeProductList:function(){
        this.$fetch(API.getWebHomeProductList).then((response) => {
          if(response.code == 200){
          this.productList = response.data;
          this.initSwiper();
        }
      });
      },

      initSwiper(){
        let self = this;
        this.$nextTick(() => {
          const swiper = new Swiper('#home-banner-swiper-container', {
            slidesPerView: 4.5,
            loop: true,
            touchRatio: 0.5,
            simulateTouch : false,//禁止鼠标模拟
            navigation: {
              nextEl: '#swiper-home-banner-next-button',
              prevEl: '#swiper-home-banner-prev-button'
            },
           /* observer:true,*/
            observeParents:true,//修改swiper的父元素时，自动初始化swiper
            on: {
              slideChangeTransitionStart: function(){
                self.sliceActive += 1;
              },
            },
          });
        })
      }
    },
    mounted() {
      this.getWebHomeProductList();
    },
    created: function () {}
  }
</script>
<style scoped lang="scss">
.swiper-box{
  .tag{
    position: absolute;
    color: #000;
    left: -6px;
    top: -114px;
    font-size: 32px;
    letter-spacing: 2px;
    transform: rotate(-22deg);
    font-weight: 500;
  }
  .swiper-container {
    width: 83.5417%;
    height: 100%;
    margin: 0 7.1875% 20px 9.2708%;
    padding: 114px 0 80px 0;
    a{
      display: block;
      width: 100%;
      color: #1C2024;
    }
    overflow: visible;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    width: calc((100%  - 132px) / 4);
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: transform .1s ease;
    overflow: hidden;
    padding: 0 0 0 20px;
  }
  .swiper-slide-active{
    /* width: calc((100% - 90px - 170px) / 4 + 170px );*/
    overflow: visible;
    position: relative;
    left: 3.5416%;
    margin-right: 8.3541% !important;
    top: 10px;
    padding:0;
    .fade-img{
      top: 0;
      right: 50.9693%;
      transform: scale(1.41);
    }

    .small-img{
      bottom: 20px;
      width: 82px;
      right: 20px;
      border-width: 4px;
    }

    .big-img{
      width: 100%;
      border-width: 8px;
    }

    .product-info{
      display: block;
      margin-top: 125px;
    }

    .show-img-box{
      transform: scale(1.38);
    }
  }  
  .swiper-slide:nth-child(odd){
    transform: translateY(-114px);
    &.swiper-slide-active{
      transform: translateY(-45px);
    }
  }
  .swiper-slide:nth-child(even){
    transform: translateY(114px);
    &.swiper-slide-active{
      transform: translateY(45px);
    }
  }
  .reset-translateY{
    .swiper-slide:nth-child(odd){      
      transform: translateY(114px);
      &.swiper-slide-active{
        transform: translateY(45px);
      }
    }
    .swiper-slide:nth-child(even){
      transform: translateY(-114px);
      &.swiper-slide-active{
        transform: translateY(-45px);
      }
    }
  }
  .swiper-slide-prev{
    opacity: 0;
  }
  .swiper-slide-next + .swiper-slide + .swiper-slide + .swiper-slide{
    opacity: 0;
  }
  .top-slide{
    width: 100%;
    position: relative;
  }

  .show-img-box{
    position: relative;
    width: 100%;
    img{
      width: 100%;
    }
  }
  .big-img,.small-img{
    border: solid #fff;
    border-radius: 50%;
    overflow: hidden;
    background: #fff;
  }
  .big-img{
    width: calc(100% - 20px);
    border-width: 7px;
  }
  .small-img{
    width: 88px;
    border-width: 4px;
    position: absolute;
    right: 0;
    bottom: 25px;
  }
  .fade-img{
    position: absolute;
    width: 100%;
    top: 600px;
    right: 600px;
    transition: right .3s ease-in-out;
    img{
      width: 100%;
    }
  }
  .product-info {
    display: none;
    text-align: center;
    margin-top: 25px;
    .title{
      min-width: 200px;
      border-radius: 10px;
      background-color: #FFFFFF;
      font-size: 22px;
      font-weight: 500;
      letter-spacing: 1.03px;
      line-height: 32px;
      padding: 13px 10px;
      display: inline-block;
      margin-bottom: 10px;
    }
    .sub-title{
      color: #EAEAEA;
      font-size: 20px;
      letter-spacing: 1.5px;
      line-height: 37px;
      margin: 0 0 14px 0;
    }
    .energy-info{
      color: #FFFFFF;
      font-size: 16px;
      font-style: italic;
      letter-spacing: 1.5px;
      line-height: 40px;
      img{
        width: 40px;
        position: relative;
        top: -5px;
      }
    }
  }
  #swiper-home-banner-prev-button,#swiper-home-banner-next-button{
    width: 40px;
    height: 40px;
    position: absolute;
    top: 300px;
    cursor: pointer;
    z-index: 6;
    outline: 0;
  }
  #swiper-home-banner-prev-button{
    left: -65px;
    background: url(../../assets/images/prev.svg) no-repeat center;
  }
  #swiper-home-banner-next-button{
    background: url(../../assets/images/next.svg) no-repeat center;
    right: -25px;
  }

}

  @media (max-width:1680px){
    .swiper-box{
      .swiper-slide-active{
        .fade-img{
          right: 53.9693%;
        }
      }
    }
  }
  @media (max-width:1440px){
    .swiper-box{
      .swiper-container{
        padding-top: 77px;
        padding-bottom: 77px;
      }
      .swiper-slide{

      }
      .swiper-slide-active{
        .small-img{
          width: 56px;
        }
        .fade-img{
          right: 55.9693%;
        }
      }
      .swiper-slide-prev{

      }
      .small-img{
        width: 76px;
      }
      .big-img{
        width: calc(100% - 18px);
      }
      .swiper-slide {
        &:nth-child(odd){
          transform: translateY(-77px);
        }
        &:nth-child(even){
          transform: translateY(77px);
        }
      }
      .reset-translateY{
        .swiper-slide {
          &:nth-child(even){
            transform: translateY(-77px);
          }
          &:nth-child(odd){
            transform: translateY(77px);
          }
        }
      }
    }

  }
  @media (max-width:1280px){
    .swiper-box{
      .swiper-container{
        padding-top: 57px;
        padding-bottom: 57px;
      }
      .swiper-slide{

      }
      .swiper-slide-active{
        .fade-img{
          right: 58.9693%;
        }
      }
      .swiper-slide-prev{

      }
      .small-img{
        width: 56px;
      }
      .big-img{
        width: calc(100% - 8px);
      }
      .swiper-slide {
        &:nth-child(odd){
          transform: translateY(-57px);
        }
        &:nth-child(even){
          transform: translateY(57px);
        }
      }
      .reset-translateY{
        .swiper-slide {
          &:nth-child(even){
            transform: translateY(-57px);
          }
          &:nth-child(odd){
            transform: translateY(57px);
          }
        }
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/default/home-banner.vue